import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getCurrentUser } from "@aws-amplify/auth";

const ProtectedRoute = ({ isAuthPage }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userRole, setUserRole] = useState(null);
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser();
        
        setIsAuthenticated(!!user); // Set to true if user exists
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const role = storedUser?.role || "user"; // Default to 'user' if no role is found
        
        setUserRole(role);
      } catch {
        setIsAuthenticated(false); // Set to false if no user
      }
    };
    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    // Add a loading spinner or placeholder while checking auth state
    return <div>Loading...</div>;
  }
  if (isAuthenticated && isAuthPage) {

  if (userRole === "Admin") {
    // If user is admin, redirect to admin dashboard
    return <Navigate to="/admin/dashboard" />;
  }
  if (userRole === "User") {
    // If user is admin, redirect to admin dashboard
    return <Navigate to="/user/dashboard" />;
  }
  if (userRole === "Approver") {
    // If user is admin, redirect to admin dashboard
    return <Navigate to="/approver/dashboard" />;
  }
  }

  if (!isAuthenticated && !isAuthPage) {
    // If user is not authenticated and trying to access a protected page, redirect to login
    return <Navigate to="/login" />;
  }

  // Render the children components (e.g., LoginPage, PricingPlans)
  return <Outlet />;
};
export default ProtectedRoute;